import { Modal } from "antd";
import { DocumentoForm } from "core/features/documentos/typings";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import FooterModal from "ui/components/Button/FooterModal";
import FormDocumento from "./FormDocumento";
import useSaveArquivo from "core/features/documentos/hooks/useSaveArquivo";
import { showErrorAxios, showSuccess } from "infra/helpers/alerta";
import useDocumento from "core/features/documentos/hooks/useDocumento";
import { UseMutationResult } from "react-query";
import { AxiosResponse } from "axios";
import { UseSaveDocumentosProps } from "core/features/documentos/typings/index";

interface ModalDocumentoProps {
  isOpen: boolean;
  onClose: () => any;
  onSave: () => any;
  documentoId?: string;
  documentoNome?: string;
  documentoPaiId?: string;
  unidadeId?: string;
  useSaveDocumento?: (
    props: UseSaveDocumentosProps
  ) => UseMutationResult<AxiosResponse<any>, unknown, DocumentoForm, unknown>;
  hideDestino?: boolean;
}

const defaultValues: Partial<DocumentoForm> = {
  nome: "",
  notificarMoradores: false,
  tipoDestinoId: null,
  file: [],
};

function ModalDocumento({
  isOpen,
  onClose,
  documentoId,
  documentoNome,
  documentoPaiId,
  unidadeId,
  onSave,
  useSaveDocumento = useSaveArquivo,
  hideDestino = false,
}: ModalDocumentoProps) {
  const [registerAnother, setRegisterAnother] = useState(false);
  const { isLoading, mutate: handleSave } = useSaveDocumento({
    id: documentoId,
    unidadeId,
  });
  const {
    data: documento,
    isLoading: isLoadingDocumento,
    isFetching: isFetchingDocumento,
  } = useDocumento(documentoId);


  const { control, reset, formState, handleSubmit, watch } =
    useForm<DocumentoForm>({
      mode: "all",
      defaultValues: { ...defaultValues, documentoPaiId },
    });

  useEffect(() => {
    if (!isOpen) {
      reset(defaultValues);
    }
  }, [isOpen, reset]);

  useEffect(() => {
    if (documentoNome) {
      reset({
        ...defaultValues,
        nome: documentoNome,
        documentoPaiId,
      });
    }
  }, [documentoNome, documentoPaiId, reset]);

  useEffect(() => {
    if (documento) {
      reset({
        destinoId: documento.destinoId,
        tipoDestinoId: documento.tipoDestinoId,
        nome: documento.nome,
        file:documento.file
      });
    }
  }, [documento, reset]);

  const onSubmit = async (data: DocumentoForm) => {
    handleSave(data, {
      onSuccess: async () => {
        const { isConfirmed } = await showSuccess();

        if (isConfirmed) {
          onSave();
        }

        if (!registerAnother) {
          onClose();
        } else {
          reset({ ...defaultValues, documentoPaiId });
        }
      },
      onError: (err) => {
        showErrorAxios(err);
      },
    });
  };

  const form = watch();

  const _isLoading = isLoading || isLoadingDocumento || isFetchingDocumento;

  return (
    <Modal
      centered
      visible={isOpen}
      footer={
        <FooterModal
          isDisabled={!formState.isValid}
          onSubmit={() => {
            handleSubmit(onSubmit)();
          }}
          showRegisterAnother={!documentoId}
          registerAnother={registerAnother}
          setRegisterAnother={setRegisterAnother}
          isLoadingSave={_isLoading}
          onClose={onClose}
        />
      }
      title={(documentoId ? "Editar" : "Criar") + " documento"}
      destroyOnClose
      onCancel={onClose}
      closable={true}
      width="600px"
    >
      <FormDocumento
        control={control}
        isEdit={!!documentoId}
        form={form}
        hideDestino={hideDestino}
        mimetype={documento?.mimetype}
        isLoading={isLoadingDocumento}
      />
    </Modal>
  );
}

export default ModalDocumento;
